import React, { useCallback, useEffect, useState } from "react";

import { adminLogin, checkAdminLogin, internalProjectSearch, uploadInternalProject, uploadProjectSource, downloadProject, getContainer, setContainer, pullStyles_Api } from "../dashboardapi";

import { Box, Button, Center, Container, Divider, FormLabel, HStack, InputGroup, InputRightElement, Link, Table, Td, Text, Th, Tr, useToast, VStack, Tooltip } from "@chakra-ui/react"
import { ChakraProvider, Input, Image } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import Custheme from "./ChakraCustom";
import { MdError, MdOutlineFileUpload, MdLogin, MdSearch, MdOutlineCode, MdArrowCircleLeft, MdSettings, MdRefresh, MdClose, MdMenu } from "react-icons/md";
import { LuLayoutTemplate } from "react-icons/lu";

import styles from "./Admin.module.css"
import Templateadmin from "./Templates/Templateadmin"
import { useDropzone } from 'react-dropzone';
import { useNavigate } from "react-router-dom";
import { useTheme } from "../Themes/ThemeContext";


//MARK:Upload Int-Project
const ProjectUpload = () => {
    const [clientname, setclientname] = useState('')
    const [projectFile, setprojectFile] = useState()
    const [projectLink, setprojectLink] = useState(null)
    const toast = useToast();

    const onDropFiles = useCallback((acceptedFiles) => {
        setprojectFile(acceptedFiles);
    }, []);

    const { getRootProps: getRootPropsFiles, getInputProps: getInputPropsFiles } = useDropzone({
        onDrop: onDropFiles,
        multiple: true
    });
    //MARK:Hardcoded
    const uploadProject = () => {
        uploadInternalProject(projectFile, clientname).then((res) => {
            if (res.data) {
                console.log(res.data.project_id);
                //dynamic host name
                const currHost = window.location.origin;
                console.log(currHost);
                var link = `${currHost}/${res.data.project_id}?token=${res.data.token}`;

                setprojectLink(link);
            } else {
                toast({
                    title: "Error uploading file",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }

    // Delete handler
    const handleDelete = () => {
        setprojectFile(null); // Removes the file from state
    };

    return (
        <Container pt={4} px={{ base: 4, md: 8, lg: 10 }} maxW={"100%"}>
            <Box w={"100%"} marginBottom={10}>
                <p style={{ fontWeight: "500" }} className={styles.titles}>Project Upload</p>
            </Box>
            <VStack gap="2" align={'start'} width={{ base: "100%", lg: "50%" }}>

                <FormLabel>Upload project file (.tar.gz)</FormLabel>
                <Box {...getRootPropsFiles()} className={styles.dropzone}>
                    <Input  {...getInputPropsFiles()} variant="outline" type="file" onChange={(e) => onDropFiles(e.target.files[0])} height={"100%"} />
                    <p>Drag & drop .tar.gz files here, or click to select files</p>
                </Box>
                {projectFile && (
                    <Box display="flex" alignItems="flex-start" justifyContent="space-between" w="100%" p={4} border="1px solid var(--border)" borderRadius="md">
                        <VStack align="start" spacing={1} w="70%">
                            <Text fontSize={["md"]} fontWeight="500" wordBreak="break-word">{projectFile.name}</Text>
                            <Text fontSize="0.75rem" color="var(--text-secondary)">{(projectFile.size / 1024).toFixed(2)} KB</Text>
                        </VStack>

                        <Button variant="ghost" p={0} ml={2} onClick={handleDelete}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_45_3546)">
                                    <path d="M3.33398 5.83301H16.6673" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.33398 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.666 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_45_3546">
                                        <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            {/* <Image src="/images/Redesignpics/Dashboard/delete.png" alt="delete" boxSize={["20px", "18px"]} /> */}
                        </Button>
                    </Box>

                )}

                <FormLabel>Client Name</FormLabel>
                <Input border="1px solid var(--border)" outline="none" background="var(--input)" color="var(--input-text)" value={clientname} placeholder="Enter Client Name" onChange={(e) => setclientname(e.target.value)} />
                <Button marginTop={"20px"} onClick={uploadProject}>Upload Project</Button>

                {projectLink ? <InputGroup size='md'>
                    <Input
                        pr='4.5rem'
                        type={'text'}
                        value={projectLink}
                    />
                    <InputRightElement width='4.5rem'>
                        <Button h='1.75rem' size='sm' onClick={() => { if (window.isSecureContext) { navigator.clipboard.writeText(projectLink) } }}>
                            Copy
                        </Button>
                    </InputRightElement>
                </InputGroup> : null}
            </VStack>
        </Container >
    );
}


//MARK:Upload Source Project
const SourceUpload = () => {
    const [projectId, setprojectId] = useState('')
    const [sourceFile, setsourceFile] = useState()
    const toast = useToast();

    const onDropFiles = useCallback((acceptedFiles) => {
        setsourceFile(acceptedFiles);
    }, []);

    const { getRootProps: getRootPropsFiles, getInputProps: getInputPropsFiles } = useDropzone({
        onDrop: onDropFiles,
        multiple: true
    });

    const uploadSource = () => {
        console.log(projectId, sourceFile)
        uploadProjectSource(sourceFile, projectId).then((res) => {
            if (res.data) {
                console.log(res.data.project_id)
                toast({
                    title: "Source uploaded",
                    description: res.data.message,
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })
            } else {
                toast({
                    title: "Error uploading file",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }
    // Delete handler
    const handleDelete = () => {
        setsourceFile(null); // Removes the file from state
    };

    return (
        <Container pt={4} px={{ base: 4, md: 8, lg: 10 }} maxW={"100%"}>
            <Box w={"100%"} marginBottom={10}>
                <p style={{ fontWeight: "500" }} className={styles.titles}>Upload Source Tex for Project</p>
            </Box>
            <VStack gap="2" align={'start'} width={{ base: "100%", lg: "50%" }}>
                <FormLabel>Upload Project Source file (.tex)</FormLabel>
                <Box {...getRootPropsFiles()} className={styles.dropzone}>
                    <Input {...getInputPropsFiles()} variant="outline" type="file" onChange={(e) => onDropFiles(e.target.files[0])} height={"100%"} />
                    <p>Drag & drop .tex files here, or click to select files</p>
                </Box>
                {sourceFile && (
                    <Box display="flex" alignItems="center" justifyContent="space-between" w="100%" p={2} border="1px solid gray" borderRadius="md">
                        <VStack align="start" spacing={0} w="70%">
                            <Text fontSize="md" fontWeight="500">{sourceFile.name}</Text>
                            <Text fontSize="0.75rem" color="var(--border)">{(sourceFile.size / 1024).toFixed(2)} KB</Text>
                        </VStack>

                        <Button variant="ghost" p={0} ml={2} onClick={handleDelete}>
                            {/* <Image src="/images/Redesignpics/Dashboard/delete.png" alt="delete" boxSize="20px" /> */}
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_45_3546)">
                                    <path d="M3.33398 5.83301H16.6673" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.33398 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.666 9.16699V14.167" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.16602 5.83301L4.99935 15.833C4.99935 16.275 5.17494 16.699 5.4875 17.0115C5.80006 17.3241 6.22399 17.4997 6.66602 17.4997H13.3327C13.7747 17.4997 14.1986 17.3241 14.5112 17.0115C14.8238 16.699 14.9993 16.275 14.9993 15.833L15.8327 5.83301" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.5 5.83333V3.33333C7.5 3.11232 7.5878 2.90036 7.74408 2.74408C7.90036 2.5878 8.11232 2.5 8.33333 2.5H11.6667C11.8877 2.5 12.0996 2.5878 12.2559 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333" stroke="var(--btn-bg)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_45_3546">
                                        <rect width="20" height="20" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </Button>
                    </Box>

                )}


                <FormLabel>Project UUID</FormLabel>
                <Input border="1px solid var(--border)" outline="none" background="var(--input)" color="var(--input-text)" value={projectId} placeholder="Enter Project UUID" onChange={(e) => setprojectId(e.target.value)} />
                <Button marginTop={"20px"} onClick={uploadSource}>Upload Source Tex</Button>
            </VStack>
        </Container >
    );
}


//MARK:Project Search
// const ProjectSearch = () => {
//     const [searhTerm, setsearchTerm] = useState('')
//     const [data, setdata] = useState(null)
//     const toast = useToast()

//     const searchProject = () => {
//         setdata(null);
//         internalProjectSearch(searhTerm).then((res) => {
//             if (res.data) {
//                 setdata(res.data.data)
//             } else {
//                 toast({
//                     title: "Please enter valid search",
//                     description: res.error.error,
//                     status: "error",
//                     duration: 2000,
//                     isClosable: "true"
//                 })
//             }
//         })
//     }
//     const handleDownload = async (projId) => {
//         try {
//             const loadToast = toast({
//                 title: "Downloading Project...",
//                 description: "Please wait while we fetch the file contents.",
//                 status: "loading",
//                 duration: null,
//                 isClosable: true
//             });
//             const fData = await downloadProject(projId);
//             toast.close(loadToast);
//             //console.log(fData.data);

//             if (!fData.data || !fData.data.content) {
//                 toast({
//                     title: "File content is empty or invalid",
//                     description: fData.data.error,
//                     status: "error",
//                     duration: 2000,
//                     isClosable: "true"
//                 })
//                 return;
//             }
//             const byteCharacters = atob(fData.data.content);
//             const byteNumbers = new Array(byteCharacters.length);
//             for (let i = 0; i < byteCharacters.length; i++) {
//                 byteNumbers[i] = byteCharacters.charCodeAt(i);
//             }
//             const byteArray = new Uint8Array(byteNumbers);
//             // Create blob
//             const blob = new Blob([byteArray], { type: "application/zip" });
//             //temporary link to trigger download
//             const link = document.createElement("a");
//             link.href = window.URL.createObjectURL(blob);
//             link.download = fData.data.name; //file name from API
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//         } catch (error) {
//             toast({
//                 title: "Download failed",
//                 description: error,
//                 status: "error",
//                 duration: 2000,
//                 isClosable: "true"
//             })
//             // console.error("Download failed", error);
//         }
//     };


//     //MARK:Search result table
//     const RenderTable = (props) => {
//         const data = props.data;
//         console.log(props.data);
//         return (
//             <ChakraProvider theme={Custheme}>
//                 <Box height={"600px"} w={"100%"} overflow={"auto"} mt={"20px"} mb={"30px"}>
//                     <Table border={"1px"} borderColor="var(--border)"  >
//                         <Tr position={"sticky"} top={"0"} zIndex={"1000"} bg={"black.500"} width={"100%"}>
//                             <Th color={"white"}>Sl. No.</Th>
//                             <Th color={"white"}>Project Name</Th>
//                             <Th color={"white"}>Project ID</Th>
//                             <Th color={"white"}>MASK ID</Th>
//                             <Th color={"white"}>Created On</Th>
//                             <Th color={"white"}>Internal Project</Th>
//                             <Th color={"white"}>Link</Th>
//                             <Th color={"white"}>Download</Th>
//                         </Tr>
//                         {data.map((i, j) => (<Tr>
//                             {/* {console.log(i.is_internal)} */}
//                             <Td>{j + 1}</Td>
//                             <Td>{i.project_name}</Td>
//                             <Td>
//                                 {i.uuids ? (
//                                     <Tooltip label={i.uuids} placement="top">
//                                         <Button
//                                             size='sm'
//                                             onClick={() => {
//                                                 if (window.isSecureContext) {
//                                                     navigator.clipboard.writeText(i.uuids);
//                                                 }
//                                             }}
//                                         >
//                                             Copy
//                                         </Button>
//                                     </Tooltip>
//                                 ) : (
//                                     <Box mx={"auto"}>N/A</Box>
//                                 )}
//                             </Td>
//                             <Td>
//                                 {i.mask_uuid ? (
//                                     <Tooltip label={i.mask_uuid} placement="top">
//                                         <Button
//                                             size='sm'
//                                             onClick={() => {
//                                                 if (window.isSecureContext) {
//                                                     navigator.clipboard.writeText(i.mask_uuid);
//                                                 }
//                                             }}
//                                         >
//                                             Copy
//                                         </Button>
//                                     </Tooltip>
//                                 ) : (
//                                     <Box mx={"auto"}>N/A</Box>
//                                 )}
//                             </Td>
//                             <Td>{i.created_at ? new Date(i.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : "N/A"}</Td>
//                             <Td fontWeight={"bold"}>{i.internal_project ? "Yes" : "No"}</Td>
//                             <Td>{i.link ? <Link mx={"auto"} href={i.link} isExternal><ExternalLinkIcon /></Link> : <Box mx={"auto"}><MdError /></Box>}</Td>
//                             <Td>
//                                 {i.uuids ? (
//                                     <Button
//                                         size='sm'
//                                         onClick={() => handleDownload(i.uuids)}
//                                     >
//                                         Download
//                                     </Button>
//                                 ) : (
//                                     <Box mx={"auto"}>N/A</Box>
//                                 )}
//                             </Td>
//                         </Tr>))}
//                     </Table>
//                 </Box>
//             </ChakraProvider>
//         )
//     }

//     return (
//         <Container pt={4} pr={10} pl={10} maxW={"100%"} maxH={"100vh"} height={"100vh"}  >
//             <VStack maxW={"100%"} h={"90vh"} display={"flex"} alignItems={"flex-start"} justifyContent={"flex-start"} >
//                 <Box w={"100%"} marginBottom={10}>
//                     <p style={{ fontSize: "32px", fontWeight: "500" }}>Project Search</p>
//                 </Box>
//                 <InputGroup size='md' width={"50%"} justifyContent={"start"} display={"flex"} flexDirection={"column"}>
//                     <Input
//                         borderColor="var(--border)"
//                         pr='4.5rem'
//                         type={'text'}
//                         value={searhTerm}

//                         placeholder='Enter Project Name'
//                         onChange={(e) => setsearchTerm(e.target.value)}
//                     />
//                     <InputRightElement width='4.5rem'>
//                         <Button h='1.75rem' size='sm' onClick={searchProject}>
//                             Search
//                         </Button>
//                     </InputRightElement>
//                 </InputGroup>
//                 {data ? <RenderTable data={data} /> : null}
//             </VStack>
//         </Container>
//     )
// }
const ProjectSearch = () => {
    const [searhTerm, setsearchTerm] = useState('')
    const [data, setdata] = useState(null)
    const toast = useToast()

    const searchProject = () => {
        setdata(null);
        internalProjectSearch(searhTerm).then((res) => {
            if (res.data) {
                setdata(res.data.data)
            } else {
                toast({
                    title: "Please enter valid search",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }

    const handleDownload = async (projId) => {
        try {
            const loadToast = toast({
                title: "Downloading Project...",
                description: "Please wait while we fetch the file contents.",
                status: "loading",
                duration: null,
                isClosable: true
            });
            const fData = await downloadProject(projId);
            toast.close(loadToast);

            if (!fData.data || !fData.data.content) {
                toast({
                    title: "File content is empty or invalid",
                    description: fData.data.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
                return;
            }
            const byteCharacters = atob(fData.data.content);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/zip" });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fData.data.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            toast({
                title: "Download failed",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    };

    // MARK: Mobile card — replaces one table row on small screens
    const MobileCard = ({ i, j }) => (
        <Box
            border="1px solid var(--border)"
            borderRadius="md"
            p={4}
            w="100%"
            mb={3}
            bg="var(--bg-overlay)"
        >
            <Text fontWeight="600" fontSize="15px" mb={2}>
                {j + 1}. {i.project_name}
            </Text>

            <Box display="flex" flexDirection="column" gap={2} fontSize="13px">
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Text color="var(--text-secondary)">Project ID</Text>
                    {i.uuids ? (
                        <Tooltip label={i.uuids} placement="top">
                            <Button size="xs" onClick={() => { if (window.isSecureContext) navigator.clipboard.writeText(i.uuids) }}>
                                Copy
                            </Button>
                        </Tooltip>
                    ) : <Text>N/A</Text>}
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Text color="var(--text-secondary)">Mask ID</Text>
                    {i.mask_uuid ? (
                        <Tooltip label={i.mask_uuid} placement="top">
                            <Button size="xs" onClick={() => { if (window.isSecureContext) navigator.clipboard.writeText(i.mask_uuid) }}>
                                Copy
                            </Button>
                        </Tooltip>
                    ) : <Text>N/A</Text>}
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Text color="var(--text-secondary)">Created on</Text>
                    <Text>
                        {i.created_at
                            ? new Date(i.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })
                            : "N/A"}
                    </Text>
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Text color="var(--text-secondary)">Internal</Text>
                    <Text fontWeight="bold">{i.internal_project ? "Yes" : "No"}</Text>
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Text color="var(--text-secondary)">Link</Text>
                    {i.link
                        ? <Link href={i.link} isExternal color="var(--btn-bg)">Open <ExternalLinkIcon mx="2px" /></Link>
                        : <MdError />}
                </Box>

                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Text color="var(--text-secondary)">Download</Text>
                    {i.uuids
                        ? <Button size="xs" onClick={() => handleDownload(i.uuids)}>Download</Button>
                        : <Text>N/A</Text>}
                </Box>
            </Box>
        </Box>
    );

    // MARK: Search result table
    const RenderTable = (props) => {
        const data = props.data;
        return (
            <ChakraProvider theme={Custheme}>
                {/* Desktop table */}
                <Box
                    display={["none", "none", "block"]}
                    height="600px"
                    w="100%"
                    overflow="auto"
                    mt="20px"
                    mb="30px"
                >
                    <Table border="1px" borderColor="var(--border)">
                        <Tr position="sticky" top="0" zIndex="1000" bg="black.500" width="100%">
                            <Th color="white">Sl. No.</Th>
                            <Th color="white">Project Name</Th>
                            <Th color="white">Project ID</Th>
                            <Th color="white">MASK ID</Th>
                            <Th color="white">Created On</Th>
                            <Th color="white">Internal Project</Th>
                            <Th color="white">Link</Th>
                            <Th color="white">Download</Th>
                        </Tr>
                        {data.map((i, j) => (
                            <Tr key={j}>
                                <Td>{j + 1}</Td>
                                <Td>{i.project_name}</Td>
                                <Td>
                                    {i.uuids ? (
                                        <Tooltip label={i.uuids} placement="top">
                                            <Button size='sm' onClick={() => { if (window.isSecureContext) navigator.clipboard.writeText(i.uuids) }}>
                                                Copy
                                            </Button>
                                        </Tooltip>
                                    ) : <Box mx="auto">N/A</Box>}
                                </Td>
                                <Td>
                                    {i.mask_uuid ? (
                                        <Tooltip label={i.mask_uuid} placement="top">
                                            <Button size='sm' onClick={() => { if (window.isSecureContext) navigator.clipboard.writeText(i.mask_uuid) }}>
                                                Copy
                                            </Button>
                                        </Tooltip>
                                    ) : <Box mx="auto">N/A</Box>}
                                </Td>
                                <Td>{i.created_at ? new Date(i.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : "N/A"}</Td>
                                <Td fontWeight="bold">{i.internal_project ? "Yes" : "No"}</Td>
                                <Td>{i.link ? <Link mx="auto" href={i.link} isExternal><ExternalLinkIcon /></Link> : <Box mx="auto"><MdError /></Box>}</Td>
                                <Td>
                                    {i.uuids
                                        ? <Button size='sm' onClick={() => handleDownload(i.uuids)}>Download</Button>
                                        : <Box mx="auto">N/A</Box>}
                                </Td>
                            </Tr>
                        ))}
                    </Table>
                </Box>

                {/* Mobile cards */}
                <Box
                    display={["block", "block", "none"]}
                    w="100%"
                    mt={4}
                    mb={6}
                    maxH="70vh"
                    overflowY="auto"
                >
                    {data.map((i, j) => (
                        <MobileCard key={j} i={i} j={j} />
                    ))}
                </Box>
            </ChakraProvider>
        )
    }

    return (
        <Container pt={4} pr={[4, 6, 10]} pl={[4, 6, 10]} maxW="100%" maxH="100vh" height="100vh">
            <VStack maxW="100%" h="90vh" display="flex" alignItems="flex-start" justifyContent="flex-start">

                <Box w="100%" marginBottom={[4, 6, 10]}>
                    <p style={{ fontWeight: "500" }} className={styles.titles}>Project Search</p>
                </Box>

                <InputGroup size='md' width={["100%", "75%", "50%"]}>
                    <Input
                        borderColor="var(--border)"
                        pr='4.5rem'
                        type='text'
                        value={searhTerm}
                        placeholder='Enter Project Name'
                        onChange={(e) => setsearchTerm(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && searchProject()}
                    />
                    <InputRightElement width='4.5rem'>
                        <Button h='1.75rem' size='sm' onClick={searchProject}>
                            Search
                        </Button>
                    </InputRightElement>
                </InputGroup>

                {data ? <RenderTable data={data} /> : null}
            </VStack>
        </Container>
    )
}

//MARK:Container Manager
const ContainerManager = () => {
    const [containerName, setContainerName] = useState('');
    const toast = useToast();

    useEffect(() => {
        getContainer().then((res) => {
            if (res.data) {
                setContainerName(res.data.container);
            }
        });
    }, []);

    const handleSetContainer = () => {
        setContainer(containerName).then((res) => {
            if (res.data) {
                toast({
                    title: "Container updated",
                    description: "Container name has been updated successfully.",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: "Update failed",
                    description: res.error ? res.error.error : "Something went wrong",
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
            }
        });
    };

    return (
        <Container pt={4} px={{ base: 4, md: 8, lg: 10 }} maxW={"100%"}>
            <Box w={"100%"} marginBottom={10}>
                <p style={{ fontWeight: "500" }} className={styles.titles}>Manage Container</p>
            </Box>
            <VStack gap="2" align={'start'} w={{ base: "100%", lg: "50%" }}>
                <FormLabel>Container Name</FormLabel>
                <Input
                    border="1px solid var(--border)"
                    outline="none"
                    background="var(--input)"
                    color="var(--input-text)"
                    value={containerName}
                    placeholder="Enter Container Name"
                    onChange={(e) => setContainerName(e.target.value)}
                />
                <Button marginTop={"20px"} onClick={handleSetContainer}>Set Container</Button>
            </VStack>
        </Container>
    );
};

//MARK:Pull Styles
const PullStyles = () => {
    const toast = useToast();
    const [isLoading, setIsLoading] = useState(false);

    const handlePullStyles = () => {
        setIsLoading(true);
        pullStyles_Api().then((res) => {
            setIsLoading(false);
            if (res.data) {
                toast({
                    title: "Success",
                    description: res.data.message || "Styles pulled successfully.",
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
            } else {
                toast({
                    title: "Failed",
                    description: res.error ? res.error.error : "Failed to pull styles.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            }
        });
    };

    return (
        <Container pt={4} px={{ base: 4, md: 8, lg: 10 }} maxW={"100%"}>
            <Box w={"100%"} marginBottom={10}>
                <p style={{ fontWeight: "500" }} className={styles.titles}>Pull Styles</p>
            </Box>
            <VStack gap="4" align={'start'} w={"100%"}>
                <Text>Trigger a pull of the latest styles from the source.</Text>
                <Button
                    leftIcon={<MdRefresh />}
                    colorScheme="teal"
                    isLoading={isLoading}
                    onClick={handlePullStyles}
                >
                    Pull Styles Now
                </Button>
            </VStack>
        </Container>
    );
};

const Admin = () => {
    const [isLoggedIn, setisLoggedIn] = useState(false);
    const [loginChecked, setloginChecked] = useState(false);
    const [selectedMenu, setselectedMenu] = useState(1);
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const navigate = useNavigate();
    const { theme } = useTheme()
    useEffect(() => {
        if (!isLoggedIn && !loginChecked) { checkLogin() };
    })

    const checkLogin = () => {
        checkAdminLogin().then((res) => {
            if (res.data) {
                console.log("Admin already logged in.")
                setisLoggedIn(true);
                setloginChecked(true);
            } else {
                setisLoggedIn(false)
                navigate("/loginnew/signin")
            }
        })
    }
    const handleMenuClick = (id) => {
        setselectedMenu(id);
        setIsMobileOpen(false);
    };

    const buttons = [
        { id: 1, label: "Upload Internal Project", icon: <MdOutlineFileUpload iconSpacing="4px" size={24} /> },
        { id: 2, label: "Search Internal Project", icon: <MdSearch iconSpacing="4px" size={24} /> },
        { id: 3, label: "Templates", icon: <LuLayoutTemplate iconSpacing="4px" size={24} style={{ marginRight: "10px" }} /> },
        { id: 4, label: "Upload Source for Project", icon: <MdOutlineCode iconSpacing="4px" size={24} /> },
        { id: 5, label: "Container Manager", icon: <MdSettings iconSpacing="4px" size={24} /> },
        { id: 6, label: "Pull Styles", icon: <MdRefresh iconSpacing="4px" size={24} /> },
    ];

    console.log(isLoggedIn);

    //MARK:Sidebar buttons left
    // return (
    //     isLoggedIn &&
    //     <ChakraProvider toastOptions={{ defaultOptions: { position: "top" } }} theme={Custheme}>
    //         <VStack VStack >
    //             <HStack w={'100%'}>
    //                 <VStack alignSelf={'center'}
    //                     display={"flex"}
    //                     justifyContent={"flex-start"}
    //                     w={["40%", "30%", "20%"]} bg={"var(--bg-overlay)"} height={"100vh"} >

    //                     {/* <Button onClick={() => { setselectedMenu(0) }} width={'100%'} leftIcon={<MdLogin />} colorScheme='teal' variant='solid'>Login as Admin</Button> */}

    //                     <Box borderBottom="1px solid var(--border)" w="100%" height="80px">
    //                         <a href="/dashboard/myprojects">
    //                             <Image
    //                                 width={["100%", "90%"]}
    //                                 height="40px"
    //                                 mr={[28, 0, 0]}
    //                                 mt={4}
    //                                 objectFit="contain"
    //                                 src={theme === "dark" ? process.env.PUBLIC_URL + "/images/dark-logo.png" : "/images/white-logo.png"}
    //                                 alt="EditLatex"
    //                             />
    //                         </a>
    //                     </Box>

    //                     {buttons.map((btn) => (
    //                         <Button
    //                             key={btn.id}
    //                             onClick={() => setselectedMenu(btn.id)}
    //                             width="100%"
    //                             height={16}
    //                             padding="5%"
    //                             borderRadius={0}
    //                             leftIcon={btn.icon}
    //                             whiteSpace="normal"
    //                             bg={"var(--bg-overlay)"}
    //                             color="var(--text-primary)"
    //                             _hover={{ bg: "#1a1a1a", color: "white" }}
    //                             justifyContent="flex-start"
    //                             fontSize="14px"
    //                             iconSpacing="4px"
    //                             borderRight={selectedMenu === btn.id ? "6px solid var(--btn-bg)" : "6px solid transparent"}
    //                         >
    //                             {btn.label}
    //                         </Button>
    //                     ))}

    //                     <Button onClick={() => navigate("/dashboard/myprojects")} width={'100%'}
    //                         leftIcon={<MdArrowCircleLeft iconSpacing="4px" size={22} />}
    //                         bg={"var(--bg-overlay)"}
    //                         color="var(--text-primary)"
    //                         _hover={{ bg: "#1a1a1a", color: "white" }}
    //                         borderRadius={0}
    //                         height={16}
    //                         padding="4%"
    //                         marginTop={"auto"}
    //                         whiteSpace="normal"
    //                         justifyContent="flex-start"
    //                     >Back to Projects</Button>
    //                 </VStack>

    //                 <Container maxW={"100%"} margin={0} height={"100vh"} overflowY={"hidden"} >
    //                     {/* {selectedMenu === 0 && !isLoggedIn ? <LoginAdmin /> : <Text>Already logged in.</Text>} */}

    //                     <div style={{
    //                         width: "100%",
    //                         height: "80px",
    //                         fontFamily: "Inter",
    //                         paddingTop: "9px", paddingLeft: "40px", paddingRight: "20px",
    //                         borderBottom: "1px solid var(--border)",
    //                         fontSize: ["38px"], fontWeight: "500"
    //                     }}>Admin Panel</div>

    //                     {selectedMenu === 1 && isLoggedIn ? <ProjectUpload /> : null}
    //                     {selectedMenu === 2 && isLoggedIn ? <ProjectSearch /> : null}
    //                     {selectedMenu === 3 && isLoggedIn ? <Templateadmin /> : null}
    //                     {selectedMenu === 4 && isLoggedIn ? <SourceUpload /> : null}
    //                     {selectedMenu === 5 && isLoggedIn ? <ContainerManager /> : null}
    //                     {selectedMenu === 6 && isLoggedIn ? <PullStyles /> : null}
    //                 </Container>
    //             </HStack>
    //         </VStack >
    //     </ChakraProvider>
    // );
    return (
        isLoggedIn && (
            <ChakraProvider toastOptions={{ defaultOptions: { position: "top" } }} theme={Custheme}>
                <Box display={{ base: "block", md: "flex" }} minH="100vh" w="100%">

                    <VStack
                        w={{ base: "100%", md: "25%", lg: "20%" }}
                        bg="var(--bg-overlay)"
                        borderRight={{ base: "none", md: "1px solid var(--border)" }}
                        borderBottom={{ base: "1px solid var(--border)", md: "none" }}
                        p={{ base: 4, md: 0 }}
                        align="stretch"
                        spacing={0}
                        position={{ base: "sticky", md: "fixed" }}
                        top={0}
                        left={0}
                        h={{ base: "70px", md: "100vh" }}
                        zIndex={100}
                    >

                        <HStack justify="space-between" px={{ base: 0, lg: 4 }} h="80px" w="100%" >
                            <a href="/dashboard/myprojects">
                                <Image
                                    w="140px"
                                    h="40px"
                                    objectFit="contain"
                                    src={theme === "dark" ? process.env.PUBLIC_URL + "/images/dark-logo.png" : "/images/white-logo.png"}
                                    alt="EditLatex"
                                />
                            </a>
                            <Button
                                display={{ base: "flex", md: "none" }}
                                onClick={() => setIsMobileOpen(!isMobileOpen)}
                                variant="ghost"
                                fontSize="24px"
                            >
                                {isMobileOpen ? <MdClose /> : <MdMenu />}
                            </Button>
                        </HStack>

                        <VStack
                            display={{ base: isMobileOpen ? "flex" : "none", md: "flex" }}
                            align="stretch"
                            spacing={0}
                            pb={{ base: 4, md: 0 }}
                            position={{ base: "absolute", md: "static" }}
                            top={{ base: "70px", md: "auto" }}
                            left={{ base: 0, md: "auto" }}
                            w={{ base: "100%", md: "auto" }}
                            bg="var(--bg-overlay)"
                            zIndex={99}
                            borderBottom={{ base: "1px solid var(--border)", md: "none" }}
                            boxShadow={{ base: "0 4px 12px rgba(0,0,0,0.15)", md: "none" }}
                        >
                            {buttons.map((btn) => (
                                <Button
                                    key={btn.id}
                                    onClick={() => handleMenuClick(btn.id)}
                                    width="100%"
                                    height={14}
                                    borderRadius={0}
                                    leftIcon={btn.icon}
                                    whiteSpace="normal"
                                    bg="var(--bg-overlay)"
                                    color="var(--text-primary)"
                                    _hover={{ bg: "#1a1a1a", color: "white" }}
                                    justifyContent="flex-start"
                                    fontSize="14px"
                                    iconSpacing="8px"
                                    borderLeft={{ base: selectedMenu === btn.id ? "6px solid var(--btn-bg)" : "6px solid transparent", md: "none" }}
                                    borderRight={{ base: "none", md: selectedMenu === btn.id ? "6px solid var(--btn-bg)" : "6px solid transparent" }}
                                >
                                    {btn.label}
                                </Button>
                            ))}

                            <Button
                                onClick={() => navigate("/dashboard/myprojects")}
                                width='100%'
                                leftIcon={<MdArrowCircleLeft iconSpacing="4px" size={22} />}
                                bg="var(--bg-overlay)"
                                color="var(--text-primary)"
                                _hover={{ bg: "#1a1a1a", color: "white" }}
                                borderRadius={0}
                                height={14}
                                mt={{ base: 2, md: "auto" }}
                                justifyContent="flex-start"
                            >
                                Back to Projects
                            </Button>
                        </VStack>
                    </VStack>


                    <Box
                        flex={1}
                        ml={{ base: 0, md: "25%", lg: "20%" }}
                        pt={{ base: 4, md: 0 }}
                        height="100vh"
                        overflowY="auto"
                    >

                        <Box
                            w="100%"
                            height="80px"
                            display={{ base: "none", md: "flex" }}
                            alignItems="center"
                            pl="40px"
                            borderBottom="1px solid var(--border)"
                            fontSize="28px"
                            fontWeight="500"
                        >
                            Admin Panel
                        </Box>

                        <Box p={{ base: 0, md: 6 }} >
                            {selectedMenu === 1 && isLoggedIn ? <ProjectUpload /> : null}
                            {selectedMenu === 2 && isLoggedIn ? <ProjectSearch /> : null}
                            {selectedMenu === 3 && isLoggedIn ? <Templateadmin /> : null}
                            {selectedMenu === 4 && isLoggedIn ? <SourceUpload /> : null}
                            {selectedMenu === 5 && isLoggedIn ? <ContainerManager /> : null}
                            {selectedMenu === 6 && isLoggedIn ? <PullStyles /> : null}
                        </Box>
                    </Box>
                </Box>
            </ChakraProvider>
        )
    );
};

export default Admin
